export default __webpack_public_path__ + "static/media/artwork-3.2be724e0.png";